module.exports = __webpack_public_path__ + "img/solution_partner_msyh@2x.efc1cb0b.png";